/**
 * DTO de entrada de suscripciones (`PUT /orgs/:orgId/subscriptions/:moduleCode`). Ver
 * docs/FASE-0.md §5 "Suscripciones". La salida ya existe como `SubscriptionSchema` en
 * `../webhooks.js`.
 */
import { z } from "zod";
import { PATTERNS } from "../constants.js";
import { FeatureValueSchema, SubscriptionStatusSchema } from "../entitlements.js";
/** `overrides` pisa el plan: mismo shape que `SubscriptionOverrides` de `@continnua/platform-db`. */
export const SubscriptionOverridesInputSchema = z.object({
    features: z.record(z.string().regex(PATTERNS.KEY), FeatureValueSchema).optional(),
    limits: z.record(z.string().regex(PATTERNS.KEY), z.number().nullable()).optional(),
});
export const UpsertSubscriptionInputSchema = z.object({
    planCode: z.string().regex(PATTERNS.KEY),
    seats: z.number().int().nonnegative().nullable().optional(),
    status: SubscriptionStatusSchema.optional(),
    trialEndsAt: z.iso.datetime().nullable().optional(),
    overrides: SubscriptionOverridesInputSchema.optional(),
});
//# sourceMappingURL=subscriptions.js.map